import '../scss/main.scss';

import('efile-ui/dist/core').then(() => {});
import('efile-ui/dist/collapse').then(() => {});

import './modules/cookies';

import('./shared/systemscan').then(() => {});
import('./modules/gov-whitelist').then(() => {});
import('./modules/clump').then(() => {});


(function() {

  $('.shortcuts-label').on('click', function () {
    if (window.innerWidth < 992) {
      $('.shortcuts-content').toggleClass('open');
      $('.shortcuts-menu').slideToggle(200);
    }
  });

  $('.nav-box .td__title').on('click', function () {
    if (window.innerWidth < 992) {
      $(this).parent().toggleClass('open');
      $('.nav-box .td__plain').slideToggle();
    }
  });


  if(window.location.hash) {
    const anchor = $(window.location.hash);
    if(anchor.length) {
      $(anchor).parent().children('.help__header').removeClass('collapsed');
      $(anchor).parent().children('.collapse').addClass('show');
    }
  }

  $('.help__header').on('click', function() {
    $(this).toggleClass('collapsed');
    $(this).siblings('.collapse').slideToggle();
  });

  $('[data-banner-src]').each(function(i, item) {
    $(item).parent().html(`<iframe frameborder="0" scrolling="no" src="${item.getAttribute('data-banner-src')}"></iframe>`);
  });

  if ($('.copy-btn').length || $('.gov-white-list-result').length) {
    import('./shared/copy').then(() => {});
  }

  if ($('[rel*="lightbox"]').length) {
    import('./shared/lightbox').then(() => {});
  }

  import('./shared/buttons').then(() => {});

  function loadImage(el) {
    const img = new Image(), src = el.data('src');

    img.onload = function() {
      el.attr('src', src);
      el.siblings('.loader').remove();
    };

    img.src = src;
  }

  $('img[data-src]').each(function(index, img) {
    loadImage($(img));
  });

})();
